export const LandActiveIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4 13.5L9.4 16.5C9.4 16.8866 9.0866 17.2 8.7 17.2C8.3134 17.2 8 16.8866 8 16.5L8 13.5L9.4 13.5Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9998 0.299988C5.2995 0.299988 2.2998 3.29968 2.2998 6.99999C2.2998 10.3606 4.77399 13.1433 8.00015 13.6259V10.0008V9.99918V8.43262L6.3871 7.62609C6.04132 7.4532 5.90116 7.03273 6.07405 6.68695C6.24695 6.34116 6.66742 6.201 7.0132 6.3739L8.00015 6.86737V6C8.00015 5.6134 8.31355 5.3 8.70015 5.3C9.08675 5.3 9.40015 5.6134 9.40015 6V7.98593C9.40036 7.99565 9.40036 8.00539 9.40015 8.01514V8.31005L10.2052 7.50502C10.4785 7.23165 10.9218 7.23165 11.1951 7.50502C11.4685 7.77839 11.4685 8.2216 11.1951 8.49497L9.40015 10.2899L9.40015 13.6882C12.9141 13.4811 15.6998 10.5659 15.6998 6.99999C15.6998 3.29968 12.7001 0.299988 8.9998 0.299988Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6 14.3H4.99981C4.75672 14.3 4.53104 14.4262 4.40364 14.6332L0.403644 21.1332C0.270734 21.3492 0.265032 21.6201 0.388737 21.8415C0.512443 22.0629 0.746207 22.2 0.999805 22.2H22.9998C23.2534 22.2 23.4872 22.0629 23.6109 21.8415C23.7346 21.6201 23.7289 21.3492 23.596 21.1332L19.596 14.6332C19.4686 14.4262 19.2429 14.3 18.9998 14.3H8V16.5C8 16.8866 7.6866 17.2 7.3 17.2C6.9134 17.2 6.6 16.8866 6.6 16.5V14.3Z"
        fill="#2ED0FF"
      />
    </svg>
  );
};
